// extracted by mini-css-extract-plugin
export default {"scroll_menus":"ScrollBar_scroll_menus__D2Ktr","scroll-appear":"ScrollBar_scroll-appear__BGpN6","scroll_bar_menu":"ScrollBar_scroll_bar_menu__XZX86"};